import React from 'react';

export const ErrorValidationMessage = ({ message } ) => {
  return (
    <small className="p-error">{ message }</small>
  );
}

